import { Languages } from 'lucide-react';
import { useI18n } from '@/hooks/useI18n';

export function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const { language, setLanguage, t } = useI18n();
  return (
    <label className="flex h-11 shrink-0 items-center gap-1.5 rounded-[10px] border border-line-1 bg-bg-1 px-2 text-[12px] text-text-2 transition-colors focus-within:ring-2 focus-within:ring-violet/30 hover:border-line-2 sm:h-9 sm:px-2.5">
      <Languages
        className={compact ? 'hidden size-4 shrink-0 sm:block' : 'size-4 shrink-0'}
        aria-hidden="true"
      />
      <span className="sr-only">{t('Langue', 'Language')}</span>
      <select
        value={language}
        onChange={(event) => setLanguage(event.target.value === 'en' ? 'en' : 'fr')}
        className="min-w-0 cursor-pointer bg-transparent outline-none"
      >
        <option value="fr" lang="fr">
          {compact ? 'FR' : 'Français'}
        </option>
        <option value="en" lang="en">
          {compact ? 'EN' : 'English'}
        </option>
      </select>
    </label>
  );
}
